/** Sales desk permission string constants. */
export const SalesPermissions = {
  manage: 'sales_manage',
  lead: 'sales_lead',
  access: ['sales_manage', 'sales_lead'] as const,
} as const

/**
 * Labour-supply Sales CRM UI is dark-launched for local/dev workspace only.
 * Staging and production builds omit Sales CRM routes and menu items.
 */
export function isSalesFeatureEnabled(): boolean {
  const flavor = String(import.meta.env.VITE_APP_FLAVOR ?? '')
    .trim()
    .toLowerCase()
  return flavor !== 'production' && flavor !== 'staging'
}

export function canLeadSalesTeam(capabilities: readonly string[] | null | undefined): boolean {
  if (!capabilities) return false
  return capabilities.includes(SalesPermissions.lead)
}
